/**
 * Local stubs for @saleor/app-sdk/app-bridge types and utilities.
 * This is used to decouple AntartiQA from the Saleor App SDK while keeping
 * the internal extension management logic intact.
 */

export type ThemeType = "light" | "dark";

export interface Actions {
  type: any;
  payload?: any;
}

export interface HandshakeEvent {
  type: "handshake";
  payload: {
    token: string;
    version: number;
    saleorVersion?: string;
    dashboardVersion?: string;
  };
}

export interface FormEvent {
  type: "form" | "formPayload";
  payload: any;
}

export interface ResponseEvent {
  type: "response";
  payload: {
    actionId: string;
    ok: boolean;
  };
}

export type Events = HandshakeEvent | FormEvent | ResponseEvent;

// For compatibility with code using the old name
export type DispatchResponseEvent = ResponseEvent;

export interface NotificationAction extends Actions {
  type: "notification";
  payload: {
    actionId: string;
    status?: any;
    text: string;
    title?: string;
  };
}

export interface RedirectAction extends Actions {
  type: "redirect";
  payload: {
    actionId: string;
    to: string;
    newContext?: boolean;
  };
}

export interface UpdateRouting extends Actions {
  type: "updateRouting";
  payload: {
    actionId: string;
    newRoute: string;
  };
}

export interface NotifyReady extends Actions {
  type: "notifyReady";
  payload: {
    actionId: string;
  };
}

export interface RequestPermissions extends Actions {
  type: "requestPermissions";
  payload: {
    actionId: string;
    permissions: string[];
    redirectPath: string;
  };
}

export interface FormPayloadUpdate extends Actions {
  type: "formPayloadUpdate";
  payload: {
    actionId: string;
    form: string;
    closePopup?: boolean;
    [key: string]: any;
  };
}

export interface PopupClose extends Actions {
  type: "popupClose";
  payload: {
    actionId: string;
  };
}

export interface FormPayloadProductEdit {
  form: "product-edit";
  [key: string]: any;
}

export interface FormPayloadProductTranslate {
  form: "product-translate";
  productId: string;
  translationLanguage: string;
  fields: Record<string, any>;
}

export type AllFormPayloads = FormPayloadProductEdit | FormPayloadProductTranslate;
export type AllFormPayloadUpdatePayloads = any;

export const DashboardEventFactory = {
  createHandshakeEvent: (
    token: string,
    version: number,
    versions: { core: string; dashboard: string },
  ): HandshakeEvent => ({
    type: "handshake",
    payload: {
      token,
      version,
      saleorVersion: versions.core,
      dashboardVersion: versions.dashboard,
    },
  }),
  createFormEvent: (formState: any): FormEvent => ({
    type: "form",
    payload: formState,
  }),
  createTokenRefreshEvent: (token: string): any => ({
    type: "tokenRefresh",
    payload: { token },
  }),
};
